import { Link } from 'react-router-dom';

export default function ArticleHeader() {
  return (
    <section className="pt-24 pb-12 md:pt-28 md:pb-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-300 text-sm text-foreground-600 hover:text-foreground-950 hover:border-foreground-300 transition-colors whitespace-nowrap cursor-pointer mb-8"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line"></i>
          </span>
          Back to Hub
        </Link>

        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
              In-Depth Guide
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Understanding PandabuySpreadsheet:<br />
              The 2026 Curated Guide
            </h1>
            <p className="mt-5 text-base text-foreground-600 leading-relaxed max-w-xl">
              Your complete resource for mastering PandabuySpreadsheet — from getting started to becoming a power user. Learn how curated product lists can transform your shopping experience, save you hours of manual searching, and help you discover hidden gems across every fashion category.
            </p>
            <div className="flex items-center gap-6 mt-6 text-xs text-foreground-400">
              <span>Updated: June 2026</span>
              <span>12 min read</span>
              <span>By pandabuy.bar Team</span>
            </div>
          </div>

          <div className="flex-1 w-full flex gap-4">
            <div className="flex-1 rounded-2xl overflow-hidden" style={{ aspectRatio: '3/4', maxHeight: '400px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20digital%20spreadsheet%20displayed%20on%20laptop%20screen%20alongside%20curated%20fashion%20items%20on%20minimal%20desk%2C%20soft%20afternoon%20light%20through%20window%20blinds%2C%20editorial%20workspace%20photography%2C%20warm%20taupe%20and%20cream%20interior%2C%20productive%20organized%20aesthetic&width=600&height=800&seq=article-hero-v2&orientation=portrait"
                alt="Understanding PandabuySpreadsheet Guide"
                className="w-full h-full object-cover object-top"
                title="PandabuySpreadsheet 2026 Curated Guide"
              />
            </div>
            <div className="hidden md:flex flex-col gap-4 w-28">
              <div className="rounded-xl overflow-hidden flex-1">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20premium%20leather%20sneaker%20texture%20and%20stitching%20detail%20on%20dark%20surface%2C%20macro%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20luxury%20footwear%20detail%20shot%2C%20warm%20side%20lighting%20highlighting%20material%20quality&width=300&height=300&seq=article-thumb1-v2&orientation=squarish"
                  alt="Related product"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-xl overflow-hidden flex-1">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20elegant%20minimalist%20watch%20with%20brown%20leather%20strap%20on%20grey%20stone%2C%20macro%20product%20photography%20with%20soft%20natural%20light%2C%20timeless%20accessory%20detail%20shot%2C%20clean%20sophisticated%20aesthetic&width=300&height=300&seq=article-thumb2-v2&orientation=squarish"
                  alt="Related accessory"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}